import { render, staticRenderFns } from "./ladingBill.vue?vue&type=template&id=a609c288"
import script from "./ladingBill.vue?vue&type=script&lang=js"
export * from "./ladingBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports